<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row" *ngIf="loaded && isQbpay()">
  <div class="col-md-12">
    <fieldset>
      <legend class="row">
        <div class="col-md-6">QBPay</div>
        <div class="col-md-6" *ngIf="!editable">
          <button
            class="btn btn-primary float-right"
            *ngIf="hasQBPayDetails() && isMerchantActive() && !editable"
            (click)="this.editable = true"
          >
            <span>
              <fa-icon [icon]="faEditPencil"></fa-icon>
            </span>
            Edit QBPay Details
          </button>
        </div>
      </legend>
      <div *ngIf="!editable">
        <div class="table-block">
          <div class="recordRow">
            <div class="recordLabel">Refresh Token</div>
            <div id="refreshToken" class="recordValue">
              {{
                merchant.accountDetails.qbPayAccountDetails.qbpayRefreshToken
              }}
            </div>
          </div>

          <div class="recordRow">
            <div class="recordLabel">Expiration Date</div>
            <div id="expirationDate" class="recordValue">
              {{
                merchant.accountDetails.qbPayAccountDetails
                  .qbpayRefreshTokenExpiry
              }}
            </div>
          </div>
          <div class="recordRow">
            <div class="recordLabel">Realm ID</div>
            <div id="realmId" class="recordValue">
              {{ merchant.accountDetails.qbPayAccountDetails.qbpayRealmId }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3" *ngIf="editable">
        <form
          name="qbPayAccountDetailsForm"
          class="form-horizontal"
          novalidate
          [formGroup]="qbPayGroup"
          (submit)="updateQBPayDetails()"
        >
          <app-edit-qbpay-details [parentGroup]="qbPayGroup">
          </app-edit-qbpay-details>
          <app-edit-buttons
            [buttonName]="buttonName"
            [actionInProgress]="actionInProgress"
            [formInvalid]="qbPayGroup.invalid"
            (editableEvent)="receiveEditEvent($event)"
          ></app-edit-buttons>
        </form>
      </div>
    </fieldset>
  </div>
</div>
